/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { TeachingTableCtaTagEnumType } from './TeachingTableCtaTagEnum'
import { RootStoreType } from './index'

/**
 * TeachingTableCtaBase
 * auto generated base class for the model TeachingTableCtaModel.
 */
export const TeachingTableCtaModelBase = ModelBase.named('TeachingTableCta')
  .props({
    __typename: types.optional(types.literal('TeachingTableCTA'), 'TeachingTableCTA'),
    ctaText: types.union(types.undefined, types.string),
    tag: types.union(types.undefined, TeachingTableCtaTagEnumType)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TeachingTableCtaModelSelector extends QueryBuilder {
  get ctaText() {
    return this.__attr('ctaText')
  }
  get tag() {
    return this.__attr('tag')
  }
}
export function selectFromTeachingTableCta() {
  return new TeachingTableCtaModelSelector()
}

export const teachingTableCtaModelPrimitives = selectFromTeachingTableCta().ctaText.tag
